import { render } from "./BannerBF.vue?vue&type=template&id=90d7901a&scoped=true"
import script from "./BannerBF.vue?vue&type=script&lang=js"
export * from "./BannerBF.vue?vue&type=script&lang=js"

import "./BannerBF.vue?vue&type=style&index=0&id=90d7901a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d7901a"]])

export default __exports__